import React, { FC, ReactElement } from 'react';
import { withStyles } from '@mui/styles';
// Components
// Resources
import { PinProps } from './mapTypes';
import SvgIcon from '../icons/SvgIcon';
// Style
import styles from './pin-style';
import { IconAxel } from '../../resources/images';

const PositionPinComponent: FC<PinProps> = ({ classes }): ReactElement => {
    return (
        <div id="location">
            <SvgIcon icon={IconAxel.LocationIndicator} className={classes.pinPos} size="xxxlarge" />
        </div>
    );
};

export default withStyles(styles)(PositionPinComponent);
